"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _utils = require("./utils");
var _locales = require("libs/utils/locales");
var _lodash = require("lodash");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; } // bsFormGeneratorField
var _require = require('src/fp-i18n-utils'),
  getAllI18nKeys = _require.getAllI18nKeys;
var getDefaultModelForDescriptor = function getDefaultModelForDescriptor(fieldDescriptor) {
  var _fieldDescriptor$kind;
  var fields = fieldDescriptor === null || fieldDescriptor === void 0 ? void 0 : (_fieldDescriptor$kind = fieldDescriptor.kind_options) === null || _fieldDescriptor$kind === void 0 ? void 0 : _fieldDescriptor$kind.fields;
  if (!Array.isArray(fields)) {
    return;
  }
  return fields.reduce(function (model, field) {
    if (field !== null && field !== void 0 && field.default) {
      model[field.field] = field.default;
    }
    return model;
  }, {});
};
var sharedLinkFns = {
  // this is required due to the weird way angular deals with nested directives that are the "same" (by name)
  generateFormGeneratorFieldNestedObjectRenderer: function generateFormGeneratorFieldNestedObjectRenderer($compile, $templateCache, $timeout, addRevealingInputDirective) {
    if (addRevealingInputDirective === null) {
      addRevealingInputDirective = false;
    }
    var nestedEditorPlaceholderFallbackHtml = require('angular/directives/formFieldNestedObjectPlaceholder');
    return function (scope, elem) {
      if (scope.fieldDescriptor.kind !== 'nested-object') {
        return;
      }
      scope.getDefaultModelForDescriptor = function () {
        return getDefaultModelForDescriptor(scope.fieldDescriptor);
      };
      var extraButtonAttributes = '';
      if (addRevealingInputDirective) {
        extraButtonAttributes += 'data-bs-revealing-input ';
        extraButtonAttributes += 'data-prop-to-toggle="disabled"';
      }
      var nestedEditorHtml = $templateCache.get('/static/partials/components/form-generator-field-nested-object-editor.html');

      // it might not be in the cache if we're not using the template cache (for e.g. in dev mode)
      if (!nestedEditorHtml) {
        // load the placeholder (html from a module. bad bad)
        nestedEditorHtml = nestedEditorPlaceholderFallbackHtml;
      }
      nestedEditorHtml = nestedEditorHtml.replace('data-extra-button-attributes-placeholder=""', extraButtonAttributes);

      // modal open state is contained within an object because ng seems to handle that better
      var nestedEditorRequiredScope = {
        viewState: {
          isEditorModalOpen: false
        }
      };
      angular.extend(scope, nestedEditorRequiredScope);

      // "arrayify" nested fields
      var opts = function opts() {
        return scope.fieldDescriptor.kind_options;
      };
      if (!_.isArray(opts().fields) && _.isObject(opts().fields)) {
        opts().fields = _.pairs(opts().fields).reduce(function (arr, pair) {
          arr.push(_.extend(pair[1], {
            field: pair[0]
          }));
          return arr;
        }, []);
      }
      $timeout(function () {
        elem.find('td ng-form').prepend(nestedEditorHtml);
        $compile(elem.contents())(scope);
      });
    };
  }
};
var FormGeneratorFieldCtrl = /* @ngInject */function FormGeneratorFieldCtrl($log, $rootScope, $filter, $scope, $timeout, $route, i18nService, metadataService, modalService, settingsService) {
  var _$route$current, _$route$current$bluep, _$route$current$bluep2;
  var kindOptions, openI18nEditorForKeyFn, protectedFields;
  var ADD_NEW_I18N_PLACEHOLDER_VAL = $scope.ADD_NEW_I18N_PLACEHOLDER_VAL = '_ADD_NEW_I18N_';

  // only vue controllers have a componentName
  var isVueControler = Boolean($route === null || $route === void 0 ? void 0 : (_$route$current = $route.current) === null || _$route$current === void 0 ? void 0 : (_$route$current$bluep = _$route$current.blueprintMetadata) === null || _$route$current$bluep === void 0 ? void 0 : (_$route$current$bluep2 = _$route$current$bluep.controller) === null || _$route$current$bluep2 === void 0 ? void 0 : _$route$current$bluep2.componentName);
  var event = $rootScope.event;
  var humanize = $filter('humanize');
  var uppercaseFirstChar = $filter('uppercaseFirstChar');
  var getFieldLabel = function getFieldLabel() {
    var fieldLabel = $scope.fieldDescriptor.label || $scope.field;
    return uppercaseFirstChar(humanize(fieldLabel));
  };
  $scope.visible = true;
  if ($scope.fieldDescriptor.kind === 'hidden') {
    var _$scope$fieldDescript;
    var isUnchangeable = $scope.fieldDescriptor.field._editable === false;
    $scope.visible = ((_$scope$fieldDescript = $scope.fieldDescriptor.kind_options) === null || _$scope$fieldDescript === void 0 ? void 0 : _$scope$fieldDescript.hidden) === false;
    $scope.notEditable = isUnchangeable;
  }
  function checkVisibility() {
    return _checkVisibility.apply(this, arguments);
  }
  function _checkVisibility() {
    _checkVisibility = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var settingsCond, visible, _iterator, _step, _step$value, path, value;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            settingsCond = (0, _lodash.get)($scope.fieldDescriptor, 'conditions.settings');
            if (!Array.isArray(settingsCond)) {
              _context2.next = 27;
              break;
            }
            visible = false;
            _iterator = _createForOfIteratorHelper(settingsCond);
            _context2.prev = 4;
            _iterator.s();
          case 6:
            if ((_step = _iterator.n()).done) {
              _context2.next = 17;
              break;
            }
            _step$value = _step.value, path = _step$value.path, value = _step$value.value;
            _context2.next = 10;
            return settingsService.getSetting(event._id, path);
          case 10:
            _context2.t0 = _context2.sent;
            _context2.t1 = value;
            visible = _context2.t0 === _context2.t1;
            if (visible) {
              _context2.next = 15;
              break;
            }
            return _context2.abrupt("break", 17);
          case 15:
            _context2.next = 6;
            break;
          case 17:
            _context2.next = 22;
            break;
          case 19:
            _context2.prev = 19;
            _context2.t2 = _context2["catch"](4);
            _iterator.e(_context2.t2);
          case 22:
            _context2.prev = 22;
            _iterator.f();
            return _context2.finish(22);
          case 25:
            $scope.visible = visible;
            return _context2.abrupt("return", visible);
          case 27:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4, 19, 22, 25]]);
    }));
    return _checkVisibility.apply(this, arguments);
  }
  checkVisibility();
  if ($scope.isBulkEdit) {
    // to initialize the variables so we always send them (when checked) even if empty
    $scope.model[$scope.fieldDescriptor.field] = null;
  }
  $scope.checkRequiredField = function (fieldDescriptor) {
    var isRequired = (0, _lodash.get)(fieldDescriptor, 'validations.required');

    // for bulk editable forms, we also check if the checkbox is selected to consider the field as required
    // for normal forms, we only consider the validation of the field
    if ($scope.isBulkEdit) {
      return isRequired && $scope.checkedFields[fieldDescriptor.field];
    }
    return isRequired;
  };
  var fieldsToIgnore = function fieldsToIgnore(field, newValue, oldValue) {
    return (
      // custom fields
      field.kind === 'custom' ||
      // eg: data filters in forms SS-9881
      field.kind === 'nested-object' && ((0, _lodash.isEmpty)(newValue) || !(0, _lodash.get)(oldValue, 'context') && (0, _lodash.get)(newValue, 'context')) || field.kind === 'list' && !(0, _lodash.get)(oldValue, '[0].context') && newValue && (0, _lodash.get)(newValue, '[0].context') ||
      // icon fields get initialized
      field.field === 'icon' && !newValue
    );
  };

  // we watch the fields to mark automatically the checkbox if someone starts typing
  $scope.$watch('model[fieldDescriptor.field]', function (newValue, oldValue) {
    if (newValue !== oldValue && JSON.stringify(newValue) !== JSON.stringify(oldValue) && (
    // quick check for objects
    newValue || oldValue)) {
      // at least one has values (escape null and undefined cases)

      if (!isVueControler && !fieldsToIgnore($scope.fieldDescriptor, newValue, oldValue)) {
        // the custom case generates many different outputs so we ignore it due to too many false positives
        // we do not add warning when we are inside a vue controller, vue will handle the warnings, not angular
        $rootScope.setNavigationWarningMessage("You may have intended to change the ".concat(getFieldLabel(), " but you have not saved the form. ") + 'Discard your selection?');
      }
      if ($scope.isBulkEdit) {
        if ($scope.fieldDescriptor.kind === 'nested-object' && ((0, _lodash.isEmpty)(newValue) || (0, _lodash.isEqual)(newValue, getDefaultModelForDescriptor($scope.fieldDescriptor)))) {
          return;
        }
        if (newValue && !$scope.checkedFields[$scope.fieldDescriptor.field]) {
          $scope.checkedFields[$scope.fieldDescriptor.field] = true;
        }
      }
    }
  }, true);
  if ($scope.isBulkEdit && $scope.fieldDescriptor.kind === 'external' && ($scope.fieldDescriptor.kind_options || {}).type === 'targets-exceptions') {
    $scope.$watch('model.exceptions', function (newValue) {
      if (newValue && !$scope.checkedFields[$scope.fieldDescriptor.field]) {
        $scope.checkedFields[$scope.fieldDescriptor.field] = true;
      }
    });
  }
  $scope.select2Options = {
    placeholder: 'Select an option',
    minimumResultsForSearch: 6
  };

  // choice kind values filtering logic

  var filteredKindOptionsValues = [];

  // for choice kind make sure the model is a string
  var modelValue = $scope.model[$scope.fieldDescriptor.field];
  if ($scope.fieldDescriptor.kind === 'choice' && typeof modelValue === 'number') {
    $scope.model[$scope.fieldDescriptor.field] = modelValue.toString();
  }
  var refreshFilteredKindOptionsValues = function refreshFilteredKindOptionsValues(newValues, oldValues) {
    if (newValues === oldValues) {
      // don't bother if ref is the same, target NEW descriptors with new values
      return;
    }
    var kindOptions = $scope.fieldDescriptor.kind_options || {};
    if (!_.isObject(kindOptions.values)) {
      return;
    }
    filteredKindOptionsValues = metadataService.getChoiceOptionsOrderedList(kindOptions);
  };
  refreshFilteredKindOptionsValues(true); // force

  kindOptions = $scope.fieldDescriptor.kind_options;
  if (kindOptions) {
    if (kindOptions.prefill) {
      $scope.defaultDatePickerDate = (event !== null ? event.startdate : undefined) || null;
    }
    refreshFilteredKindOptionsValues();
  }
  if (_.isArray(protectedFields = $scope.model !== null ? $scope.model.fp_protected : undefined)) {
    $scope.isProtectedField = Array.from(protectedFields).includes($scope.fieldDescriptor !== null ? $scope.fieldDescriptor.field : undefined);
  }
  $scope.getKindOptionsValues = function () {
    return filteredKindOptionsValues;
  };

  // this watcher will remove nulled out values when the descriptor changes (for instance in the panes of the prefs controller)
  $scope.$watch('fieldDescriptor.kind_options.values', refreshFilteredKindOptionsValues, true);
  $scope.omitFieldLabelFinal = ['boolean', 'external'].includes($scope.fieldDescriptor.kind) ? true : $scope.omitFieldLabel;
  if ($scope.fieldDescriptor.never_show_label) {
    $scope.omitFieldLabelFinal = true;
  }
  if ($scope.fieldDescriptor.always_show_label) {
    $scope.omitFieldLabelFinal = false;
  }
  if ($scope.fieldDescriptor.kind === 'locale') {
    $scope.omitFieldLabelFinal = true;
  }

  // embed kind logic

  if ($scope.fieldDescriptor.kind === 'embed') {
    $scope.$watch('model[fieldDescriptor.field]', function (value) {
      if (!value) {
        return;
      }
      var transformed = (0, _utils.transformToEmbeddedUrls)(value);
      if (transformed !== value) {
        // give a bit of delay so the user sees that the value was processed
        $timeout(function () {
          $scope.model[$scope.fieldDescriptor.field] = transformed;
        }, 500);
      }
    });
  }

  // !!! ALL THAT FOLLOWS IS i18n SELECTOR ONLY LOGIC !!!

  if ($scope.fieldDescriptor.kind !== 'i18n') {
    return;
  }
  var i18n = null;
  $scope.availableI18nKeys = {};
  i18nService.retrieveCompiledI18n(event).then(function (_i18n) {
    var _preselectedI18nKey;
    i18n = _i18n;
    var availableI18nKeys = getAllI18nKeys(i18n).reduce(function (map, key) {
      map[key] = key;
      return map;
    }, {});
    angular.copy(availableI18nKeys, $scope.availableI18nKeys);
    $scope.i18nSelectionsLoaded = true;

    // prime the preview if we already have an i18n key set
    if (_.isEmpty($scope.selectedI18nValue) && (_preselectedI18nKey = $scope.model[$scope.fieldDescriptor.field])) {
      return $scope.selectedI18nValue = getSelectedI18nValueFn(_preselectedI18nKey);
    }
  });
  $scope.i18nSelect2Options = {
    placeholder: 'Select a shared translation',
    formatResult: function formatResult(result) {
      if ((result !== null ? result.id : undefined) !== ADD_NEW_I18N_PLACEHOLDER_VAL) {
        return result.text;
      }
      return "<i class=\"icon-circle-with-plus\"></i> ".concat(result.text);
    }
  };
  $scope.$watch('model[fieldDescriptor.field]', function (selectedI18nKey, previousI18nKey) {
    $scope.selectedI18nValue = getSelectedI18nValueFn(selectedI18nKey);
    if (selectedI18nKey !== ADD_NEW_I18N_PLACEHOLDER_VAL) {
      return;
    }
    modalService.openModalWithForm({
      title: 'Add a new translation key',
      fields: {
        key: {
          order: 1,
          validations: {
            custom: {
              errorMessage: 'Chosen key is either invalid, reserved, or already used.'
            }
          }
        }
      },
      formCanBeSaved: function formCanBeSaved(model, form) {
        var valid = (0, _locales.validateNewI18nKey)(model.key, i18n);
        var field = (0, _lodash.get)(form, 'genericFieldForm.key');
        if (field) {
          field.$setValidity('customValidator', valid);
        }
        return valid;
      }
    }).then(function (model) {
      var i18nKeyToCreate = model.key;
      // restores old value until new i18n key is created and saved
      // surprass prevent {{#spotme.tr}}null{{/spotme.tr}} in the preview

      $scope.model[$scope.fieldDescriptor.field] = previousI18nKey;
      if (!(i18nKeyToCreate !== null ? i18nKeyToCreate.length : undefined)) {
        return;
      }
      return openI18nEditorForKeyFn(i18nKeyToCreate);
    });
  });
  $scope.showAddI18nLanguageToMetadataPrompt = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(i18nFields) {
      var langs, langCode;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            langs = i18nFields.map(function (l) {
              return l.field;
            });
            _context.next = 3;
            return modalService.openModal({
              templateUrl: '/static/partials/components/modal-language-picker.html',
              scope: {
                lang: '',
                langs: langs
              }
            });
          case 3:
            langCode = _context.sent;
            if (langCode.length) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return");
          case 6:
            i18nFields.push({
              field: langCode,
              label: langCode.toUpperCase()
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  /* helper methods */

  var saveI18nUpdates = function saveI18nUpdates(i18nKey, i18nValue) {
    var errCb = function errCb(err) {
      alert('There was a problem updating the i18n dictionary.');
      return $log.error('i18n save error!', err);
    };
    return i18nService.updateOverrideNavBitWithSingleEdit(event, i18nKey, i18nValue).then(function () {
      $scope.availableI18nKeys[i18nKey] = i18nKey;
      (0, _lodash.set)(i18n, i18nKey, i18nValue);
      $scope.model[$scope.fieldDescriptor.field] = i18nKey;
      return $rootScope.setFlashMessage('The i18n dictionary was updated.');
    }, errCb);
  };
  var getSelectedI18nValueFn = $scope.getSelectedI18nValue = function (i18nKey) {
    if (i18nKey === null) {
      i18nKey = $scope.model[$scope.fieldDescriptor.field];
    }
    if (!i18nKey) {
      return;
    }
    return (0, _lodash.get)(i18n, i18nKey) || {};
  };
  return openI18nEditorForKeyFn = $scope.openI18nEditorForKey = function (i18nKey) {
    if (!i18n) {
      return;
    }
    var selectedI18nValue = $scope.selectedI18nValue;
    return modalService.openModal({
      templateUrl: '/static/partials/components/modal-i18n-editor.html',
      scope: {
        selectedI18nKey: i18nKey,
        selectedI18nValueForEdit: selectedI18nValue,
        selectedI18nMetadata: i18nService.getMetadataForI18nEditor(selectedI18nValue),
        showAddI18nLanguageToMetadataPrompt: $scope.showAddI18nLanguageToMetadataPrompt
      }
    }).then(_.bind(saveI18nUpdates, null, i18nKey, selectedI18nValue));
  };
};
FormGeneratorFieldCtrl.$inject = ["$log", "$rootScope", "$filter", "$scope", "$timeout", "$route", "i18nService", "metadataService", "modalService", "settingsService"];
module.exports = /* @ngInject */["$compile", "$templateCache", "$timeout", function ($compile, $templateCache, $timeout) {
  return {
    scope: {
      model: '=',
      fieldDescriptor: '=',
      omitFieldLabel: '=',
      showRemoveFieldLink: '=',
      isRevealing: '=',
      showAddButtonInHeaderOfExternalFieldWidgets: '=',
      saveFn: '&',
      removeFieldFn: '&',
      isBulkEdit: '=',
      checkedFields: '=',
      bulkFieldOptions: '='
    },
    templateUrl: '/static/partials/components/form-generator-field.html',
    controller: FormGeneratorFieldCtrl,
    link: sharedLinkFns.generateFormGeneratorFieldNestedObjectRenderer($compile, $templateCache, $timeout)
  };
}];